import { render, staticRenderFns } from "./UserPayslipForm.vue?vue&type=template&id=6288d75e&"
import script from "./UserPayslipForm.vue?vue&type=script&lang=js&"
export * from "./UserPayslipForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports